<template lang="pug">
  .agency-details
    h2.primary--text {{ title }}

    v-form(ref="form-agency" lazy-validation @submit.prevent="() => {}")
      v-expansion-panels.mt-4(v-model="panel" flat tile multiple)
        v-expansion-panel
          v-expansion-panel-header Agenturdaten
          v-expansion-panel-content: v-row.my-6
            v-col.pb-0(sm="6"): v-text-field(
              v-model="agency.id"
              label="ID"
              type="number"
              outlined
              readonly
            )

            v-col.pb-0(sm="6"): v-text-field(
              v-model="agency.name"
              label="Name"
              outlined
              :rules="[ rules.required ]"
            )

            v-col.pb-0(sm="6" lg="3"): v-checkbox.mt-0(
              v-model="agency.is_active"
              label="Ist aktiv"
            )

            v-col.pb-0(sm="6" lg="3"): v-checkbox.mt-0(
              v-model="agency.ignore_for_ewe"
            )
              template(#label) EWE Status <b class="mx-1">NICHT</b> beachten

        v-expansion-panel.mt-3
          v-expansion-panel-header Sonstige Stammdaten
          v-expansion-panel-content: v-row.my-6
            v-col.pb-0(sm="6"): v-text-field(
              v-model="agency.mp_einheit_nr"
              label="MPEinheitNR"
              outlined
            )

            v-col.pb-0(sm="6"): v-text-field(
              v-model="agency.mp_einheit_vermittler_nr"
              label="MPEinheitVermittlerNR"
              outlined
            )

            v-col.pb-0(sm="6"): v-text-field(
              v-model="agency.mp_op_einheit_nr"
              label="MPOpEinheitNR"
              outlined
            )

            v-col.pb-0(sm="6"): v-text-field(
              v-model="agency.mp_op_einheit_strasse"
              label="MPOpEinheitStrasse"
              outlined
            )

            v-col.pb-0(sm="6"): v-text-field(
              v-model="agency.mp_op_einheit_plz"
              label="MPOpEinheitPLZ"
              outlined
            )

            v-col.pb-0(sm="6"): v-text-field(
              v-model="agency.mp_op_einheit_ort"
              label="MPOpEinheitOrt"
              outlined
            )

      v-btn.mt-8(block color="primary" @click="onSaveAgency") Speichern

</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'

import Urls from '@/router/urls'
import FormMixin from '@/mixins/form'

@Component({
  mixins: [
    FormMixin
  ]
})
export default class AgencyDetails extends Vue {
  @Prop({ type: [ Number, String ], default: 0 }) id

  agency = {
    is_active: true,
    ignore_for_ewe: false
  }
  panel = [0]

  get title () {
    if (!this.id) {
      return 'Agentur anlegen'
    }

    return this.agency && this.agency.id
      ? `Agentur bearbeiten (${ this.agency.name })`
      : `Agentur bearbeiten`
  }

  created () {
    if (this.id) {
      this.loadAgencyDetails()
    }
  }

  loadAgencyDetails () {
    this.$axios
      .get(Urls.Agency(this.id))
      .then(res => {
        this.agency = res.data
      })
  }

  handleAddAgency (params) {
    this.$axios
      .post(Urls.CreateAgency(), params)
      .then(() => {
        this.loadAgencies()
        this.$toast.success('Daten gespeichert', 'Speichern')
        this.$router.push({
          name: 'agency-list'
        })
      })
      .catch(err => {
        this.$toast.error(err.message, 'Fehler')
      })
  }

  handleUpdateAgency (params) {
    this.$axios
      .put(Urls.Agency(this.id), params)
      .then(() => {
        this.loadAgencies()
        this.loadAgencyDetails()
        this.$toast.success('Daten gespeichert', 'Speichern')

        if (this.selectedAgency && this.selectedAgency.id === parseInt(this.id)) {
          this.selectAgency({
            id: this.selectedAgency.id,
            name: params.name
          })
        }
      })
      .catch(err => {
        this.$toast.error(err.message, 'Fehler')
      })
  }

  onSaveAgency () {
    if (!this.isFormValid('form-agency')) {
      return
    }

    if (this.id) {
      this.handleUpdateAgency(this.agency)
    } else {
      this.handleAddAgency(this.agency)
    }
  }
}
</script>
